import React, { useEffect, useState } from "react";
import {
  Box,
  Backdrop,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useAppSelector, useAppDispatch } from "../hooks";
import { getLayoutContent } from "../SharedContextStore/slices/layoutContentDetails";
import { getBrightspeedToken } from "../SharedContextStore/slices/brightspeedToken";
import { initGTM } from "../Utils/googleTags";
import { webRefreshTokenRedux } from "../../../shared/utils/Constants";
import LoginFooter from "./footerLayout";
import LoginHeader from "./loginHeader";
import store from "../SharedContextStore/store";
import "./withDashboardLayout.css";

import { useNavigate } from "react-router-dom";
import { HeaderNavContent } from "../SharedComponents/contents";
//import { getLoginHeaderContent } from "../SharedContextStore/slices/loginHeaderContent";

interface WithLoginLayoutProps {
  children: React.ReactNode;
}

const WithLoginLayout = (props: WithLoginLayoutProps) => {
  const navigate = useNavigate();
  const { children } = props;
  const dispatch = useAppDispatch();
  const appTheme = useTheme();
  const isMobileDevice = useMediaQuery(appTheme.breakpoints.down("sm"));
  const isTabletDevice = useMediaQuery(appTheme.breakpoints.down("md"));
  const [isMobileLoginSideBarOpen, setMobileLoginSideBarOpen] = useState(false);
  const [menuExpanded, setMenuExpanded] = useState("");
  const { loading, isCaptchaLoading } = useAppSelector((state) => state.user);
  const { loading:isFindUserLoading } = useAppSelector((state) => state.findUser);
  
  const { loading: nextPaymentLoader } = useAppSelector((state) => state.nextPaymentDetails);
  const addressQlificationLoading = useAppSelector(
    (state) => state?.addressQualification?.loading
  );
  const amsTokenLoading = useAppSelector((state) => state?.amsToken?.loading);
  const contentLoading = useAppSelector(
    (state) => state?.contentDetails?.loading
  );
  const globalToken = useAppSelector((state) => state?.brightspeedToken?.data);
  // const { layoutContent, loading: layoutContentLoading } = useAppSelector(
  //   (state) => state?.layoutContentDetails
  // );
  const {layoutContent, loading: layoutContentLoading } : any = HeaderNavContent();
  // const loginHeaderContent: any = useAppSelector(
  //   (state: any) => state?.loginHeaderContent?.loginHeaderContent
  // );

  // const HEADER_CONTENT_TOP_NAVIGATION_CDN =
  //   loginHeaderContent?.entry?.top_navigation;
  // const HEADER_CONTENT_MAIN_NAVIGATION_CDN =
  //   loginHeaderContent?.entry?.main_navigation;
  useEffect(() => {
    if (!layoutContent) {
      getLayoutContentAsync();
    }
    initGTM();
    if (localStorage.getItem("sibeBarClosed")) {
      localStorage.removeItem("sibeBarClosed");
    }
  }, []);

  useEffect(() => {
    if (
      !globalToken?.access_token &&
      process.env.REACT_APP_ENV === "production"
    ) {
      const source = {
        refreshToken: async () => await dispatch(getBrightspeedToken()),
        webReduxStore: store,
      };
      Object.assign(webRefreshTokenRedux, source);
      getBrightspeedTokenSync();
    }
  }, []);

  const getBrightspeedTokenSync = async () => {
    await dispatch(getBrightspeedToken());
  };

  const getLayoutContentAsync = async () => {
    await dispatch(getLayoutContent());
  };

  useEffect(() => {
    // getContent();
  }, []);

  // const getContent = async () => {
  //   await dispatch(getLoginHeaderContent());
  // };

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick =
    (clickedMenuId: string) => (event: React.MouseEvent<HTMLElement>) => {
      if (anchorEl === event.currentTarget) {
        setMenuExpanded("");
        setAnchorEl(null);
      } else {
        // event.currentTarget.classList.add("activeHeaderMenu");
        setMenuExpanded(clickedMenuId);
        setAnchorEl(event.currentTarget);
        event.stopPropagation();
      }
    };

  // const handleClickAway = (event: React.MouseEvent<HTMLElement>) => {
  //   setAnchorEl(null);
  // };

  const handleClose = (value: string) => {
    setMenuExpanded("");
    setAnchorEl(null);
    typeof value === "string" && window.open(value, "_self");
  };

  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };
    const handleSkipLink = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
      e.preventDefault();
      const mainContent = document.getElementById('main');
      if (mainContent) {
        mainContent.setAttribute('tabindex', '-1');
        mainContent.focus();
        mainContent.removeAttribute('tabindex');
      }
    };
  return (
    <Box component="div">
     <div aria-describedby="load" role="alert" aria-live="polite"></div> 
      <Backdrop
       className="custom-loader-backdrop"      
       sx={{ color: "#fff", zIndex: (theme: any) => theme.zIndex.drawer + 2 }}
        open={
          loading ||
          isFindUserLoading ||
          contentLoading ||
          layoutContentLoading ||
          isCaptchaLoading ||
          amsTokenLoading ||
          addressQlificationLoading ||
          nextPaymentLoader 
        }
       
      >
        <div className="custom-loader"></div>
        <div  id="load" style={{ position: "absolute", visibility: "hidden"}}
          tabIndex={-1}>Please wait, Loading...</div>
      </Backdrop>
      <a className="visually-hidden-focusable"  href="#main" onClick={handleSkipLink}>Skip to main content</a>   
      <LoginHeader />
      <main role="main" id="main">
      {children}
      </main>
      <LoginFooter />
    </Box>
  );
};

export default WithLoginLayout;
